import { AccountInfoContainer } from 'src/containers';

export const AccountInfo = () => <AccountInfoContainer />;
